import React from "react";
import {
  MapTo,
  ResponsiveGrid,
  withComponentMappingContext,
} from "@adobe/aem-react-editable-components";
import ComponentWrapper from "../component-wrapper";

const CustomGridEditConfig = {
  emptyLabel: "Responsive Grid",
  isEmpty: function (props) {
    return !props || !props.title || props.title.trim().length < 1;
  },
};

export class CustomGrid extends ResponsiveGrid {
  render() {
    return (
      <div {...this.containerProps}>
        <ComponentWrapper>{super.childComponents}</ComponentWrapper>
        {super.placeholderComponent}
      </div>
    );
  }
}

export default MapTo("wcm/foundation/components/responsivegrid")(
  withComponentMappingContext(CustomGrid),
  CustomGridEditConfig
);
